module.exports = __webpack_public_path__ + "img/1.2435e68e.jpg";